// project import
import dashboard from './dashboard';
import crm from './crm';
import reportesAnalisis from './reportes-analisis';
import catalogos from './catalogos';
import compras from './compras';
import ventas from './ventas';
import inventario from './inventario';
import templates from './templates';
import remisiones from './Remisiones';
import operaciones from './operaciones';
import tasksBoard from './tasks-board';
// import usuarios from './usuarios';


// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    dashboard,
    crm,
    ventas,
    operaciones,
    remisiones,
    compras,
    inventario,
    reportesAnalisis,
    catalogos,
    templates,
    tasksBoard,
  // usuarios,
  ]
};

export default menuItems;

